import { WebApiService } from '../../../../../plugins/webApiService'
import { Events } from '../../../../../plugins/events'
import { SendRequestModel } from '../../../../../plugins/models/SendRequestModel'
import CreateJobRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/CreateJobRequest';
import EditJobRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/EditJobRequest';
import RemoveJobRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/RemoveJobRequest';
import SwitchEnabledJobRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/SwitchEnabledJobRequest';
import MoveToFolderJobRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/MoveToFolderJobRequest';
import GetJobRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/GetJobRequest';
import GetJobsRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/GetJobsRequest';
import SearchJobsRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/SearchJobsRequest';
import GetJobExecuteHistoriesRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/histories/execute/GetJobExecuteHistoriesRequest';
import GetSettingsRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/settings/GetSettingsRequest';
import GetStatusHistoriesRequest from '../../../../../scheduler/manager/serverless/i-services/models/jobs/histories/status/GetStatusHistoriesRequest';
import WsResponseModelT from '../../../../../schema-builder/server/models/WsResponseModelT';
import CreateJobResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/CreateJobResponse';
import GetJobResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/GetJobResponse';
import GetJobsResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/GetJobsResponse';
import SearchJobsResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/SearchJobsResponse';
import GetJobExecuteHistoriesResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/histories/execute/GetJobExecuteHistoriesResponse';
import GetSettingsResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/settings/GetSettingsResponse';
import GetStatusHistoriesResponse from '../../../../../scheduler/manager/serverless/i-services/models/jobs/histories/status/GetStatusHistoriesResponse';

export default class JobWsController {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	CreateEvent = new Events<WsResponseModelT<CreateJobResponse>>();
	EditEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveEvent = new Events<WsResponseModelT<Boolean>>();
	SwitchEnabledEvent = new Events<WsResponseModelT<Boolean>>();
	MoveToFolderEvent = new Events<WsResponseModelT<Boolean>>();
	GetJobEvent = new Events<WsResponseModelT<GetJobResponse>>();
	GetJobsEvent = new Events<WsResponseModelT<GetJobsResponse>>();
	SearchJobsEvent = new Events<WsResponseModelT<SearchJobsResponse>>();
	GetJobExecuteHistoriesEvent = new Events<WsResponseModelT<GetJobExecuteHistoriesResponse>>();
	GetSettingsEvent = new Events<WsResponseModelT<GetSettingsResponse>>();
	GetJobStatusHistoriesEvent = new Events<WsResponseModelT<GetStatusHistoriesResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('JobWsController', 'Create', 'SchedulerAdmin', (res: WsResponseModelT<CreateJobResponse>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'Edit', 'SchedulerAdmin', (res: WsResponseModelT<Boolean>) => {
			self.EditEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'Remove', 'SchedulerAdmin', (res: WsResponseModelT<Boolean>) => {
			self.RemoveEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'SwitchEnabled', 'SchedulerAdmin', (res: WsResponseModelT<Boolean>) => {
			self.SwitchEnabledEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'MoveToFolder', 'SchedulerAdmin', (res: WsResponseModelT<Boolean>) => {
			self.MoveToFolderEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'GetJob', 'SchedulerAdmin', (res: WsResponseModelT<GetJobResponse>) => {
			self.GetJobEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'GetJobs', 'SchedulerAdmin', (res: WsResponseModelT<GetJobsResponse>) => {
			self.GetJobsEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'SearchJobs', 'SchedulerAdmin', (res: WsResponseModelT<SearchJobsResponse>) => {
			self.SearchJobsEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'GetJobExecuteHistories', 'SchedulerAdmin', (res: WsResponseModelT<GetJobExecuteHistoriesResponse>) => {
			self.GetJobExecuteHistoriesEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'GetSettings', 'SchedulerAdmin', (res: WsResponseModelT<GetSettingsResponse>) => {
			self.GetSettingsEvent.trigger(res);
		});
		webApiService.on('JobWsController', 'GetJobStatusHistories', 'SchedulerAdmin', (res: WsResponseModelT<GetStatusHistoriesResponse>) => {
			self.GetJobStatusHistoriesEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Создать джобу
	 */
	async Create(request: CreateJobRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'Create',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Редактировать Джобу
	 */
	async Edit(request: EditJobRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'Edit',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить Джобу
	 */
	async Remove(request: RemoveJobRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'Remove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Включить или выключить job
	 */
	async SwitchEnabled(request: SwitchEnabledJobRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'SwitchEnabled',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Переместить в папку
	 */
	async MoveToFolder(request: MoveToFolderJobRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'MoveToFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить Джобу
	 */
	async GetJob(request: GetJobRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'GetJob',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список Джоб
	 */
	async GetJobs(request: GetJobsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'GetJobs',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список всех Джоб
	 */
	async SearchJobs(request: SearchJobsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'SearchJobs',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить историю выполнения Джобы
	 */
	async GetJobExecuteHistories(request: GetJobExecuteHistoriesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'GetJobExecuteHistories',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить настройки Джобы
	 */
	async GetSettings(request: GetSettingsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'GetSettings',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить историю обновления статуса Джобы
	 */
	async GetJobStatusHistories(request: GetStatusHistoriesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'SchedulerAdmin',
			Controller: 'JobWsController',
			Method: 'GetJobStatusHistories',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Создать джобу
	 */
	async createAsync(request: CreateJobRequest): Promise<CreateJobResponse> {
		return new Promise<CreateJobResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'Create',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<CreateJobResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CreateJobResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Редактировать Джобу
	 */
	async editAsync(request: EditJobRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'Edit',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить Джобу
	 */
	async removeAsync(request: RemoveJobRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'Remove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Включить или выключить job
	 */
	async switchEnabledAsync(request: SwitchEnabledJobRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'SwitchEnabled',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Переместить в папку
	 */
	async moveToFolderAsync(request: MoveToFolderJobRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'MoveToFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить Джобу
	 */
	async getJobAsync(request: GetJobRequest): Promise<GetJobResponse> {
		return new Promise<GetJobResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'GetJob',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetJobResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetJobResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список Джоб
	 */
	async getJobsAsync(request: GetJobsRequest): Promise<GetJobsResponse> {
		return new Promise<GetJobsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'GetJobs',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetJobsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetJobsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список всех Джоб
	 */
	async searchJobsAsync(request: SearchJobsRequest): Promise<SearchJobsResponse> {
		return new Promise<SearchJobsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'SearchJobs',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<SearchJobsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SearchJobsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить историю выполнения Джобы
	 */
	async getJobExecuteHistoriesAsync(request: GetJobExecuteHistoriesRequest): Promise<GetJobExecuteHistoriesResponse> {
		return new Promise<GetJobExecuteHistoriesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'GetJobExecuteHistories',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetJobExecuteHistoriesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetJobExecuteHistoriesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить настройки Джобы
	 */
	async getSettingsAsync(request: GetSettingsRequest): Promise<GetSettingsResponse> {
		return new Promise<GetSettingsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'GetSettings',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetSettingsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetSettingsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить историю обновления статуса Джобы
	 */
	async getJobStatusHistoriesAsync(request: GetStatusHistoriesRequest): Promise<GetStatusHistoriesResponse> {
		return new Promise<GetStatusHistoriesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'SchedulerAdmin',
				Controller: 'JobWsController',
				Method: 'GetJobStatusHistories',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetStatusHistoriesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetStatusHistoriesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}